import {get} from "lodash"
import basket from "@irati/checkout/utils/basket"
import {Deal} from "@irati/types"

export default function willReachMaxAmount(deal: Deal, productId: string) {
  const {hasLimit, maxAllowed, dealProductConfig} = maxAllowedAmount(deal, productId)
  if (!hasLimit) {
    return false
  }

  const currentProductTotal = basket.items.find((basketItem) => basketItem.productId === productId)?.amount || 0
  const totalAfter = currentProductTotal + (dealProductConfig?.salePrice.value || 0)

  return maxAllowed > totalAfter
}

export function maxAllowedAmount(deal: Deal, productId: string) {
  const limits = get(deal, "productConfig.limits.perRedemption", false)
  const maxAllowed = limits.maxPriceBeforeDiscounts
  const dealProductConfig = deal.productConfig.products.find((prod) => prod.uuid === productId)
  if (!limits || !maxAllowed || !dealProductConfig) {
    return {hasLimit: false}
  }

  return {hasLimit: true, maxAllowed, dealProductConfig}
}
